import { FeatureSet } from './feature-set';
import {
  MemberFeature,
  MemberFeatures as MemberFeaturesType,
  ProductInterval,
  ProductName,
  ProductShortName,
  ProductSpecMap,
} from './types';

const individualFeatures: MemberFeaturesType = new Set([
  MemberFeature.AdditionalStickers,
  MemberFeature.CustomStickers,
  MemberFeature.AdditionalBoardBackgrounds,
  MemberFeature.CustomBoardBackgrounds,
  MemberFeature.LargeAttachments,
  MemberFeature.CustomEmoji,
  MemberFeature.SavedSearches,
]);

export const trelloGoldFeatures: MemberFeaturesType = new Set([
  ...individualFeatures,
  MemberFeature.Crown,
  MemberFeature.ReadSecrets,
  MemberFeature.ThreePlugins,
]);

export const trelloGoldFromBCFeatures: MemberFeaturesType = new Set([
  ...individualFeatures,
  MemberFeature.InfinitePlugins,
]);

export const products: ProductSpecMap = new Map([
  [
    10,
    {
      shortName: ProductShortName.TrelloGoldFromBC,
      name: ProductName.TrelloGoldFromBC,
      features: trelloGoldFromBCFeatures,
    },
  ],
  [
    37,
    {
      shortName: ProductShortName.TrelloGoldMonthly,
      name: ProductName.TrelloGoldMonthly,
      interval: ProductInterval.Monthly,
      price: 5,
      features: trelloGoldFeatures,
      yearlyEquivalent: 38,
    },
  ],
  [
    38,
    {
      shortName: ProductShortName.TrelloGoldYearly,
      name: ProductName.TrelloGoldYearly,
      interval: ProductInterval.Yearly,
      price: 45,
      features: trelloGoldFeatures,
    },
  ],
]);

class MemberFeatureSet extends FeatureSet {
  currentProducts = {
    monthly: 'trelloGoldMonthly',
    yearly: 'trelloGoldYearly',
  };

  currentPriceObjectForModel = () => {
    const monthlyProduct = this.currentProducts.monthly;
    const yearlyProduct = this.currentProducts.yearly;

    const monthlyProductPrice = this.getPrice(monthlyProduct);
    const yearlyProductPrice = this.getPrice(yearlyProduct);

    return {
      monthly: {
        productNumber: this.getProductNumber(monthlyProduct),
        price: monthlyProductPrice,
        monthlyPrice: monthlyProductPrice,
      },
      yearly: {
        productNumber: this.getProductNumber(yearlyProduct),
        price: this.getPrice(yearlyProduct),
        monthlyPrice: yearlyProductPrice && yearlyProductPrice / 12,
        savePercent: this.getYearlyDiscountPercent(
          yearlyProduct,
          monthlyProduct,
        ),
      },
      billingStrategy: {
        flatRate: true,
      },
    };
  };

  constructor(memberProducts: ProductSpecMap) {
    super(memberProducts);
  }
}

export const MemberFeatures = new MemberFeatureSet(products);
